import { useState } from 'react';
import type { FC } from 'react';

import { useAddToast } from '../../../contexts/ToastContext';
import { put } from '../../../redux/api';
import { LabeledCheckbox } from '../../generic';
import Accordion from '../../generic/Accordion';
import Button from '../../generic/Button';
import Card from '../../generic/Card/Card';

const ToggleInternalOrgCard: FC = () => {
  const addToast = useAddToast();
  const [shouldSetInternal, setShouldSetInternal] = useState(!!window.user?.organization.isInternal);

  const onButtonClick = async () => {
    try {
      await put('/api/organizations/toggle_internal', { flag: shouldSetInternal });
      // reload the page to reflect the change in the Organization Info card
      window.location.reload();
    } catch (_err) {
      addToast({
        type: 'error',
        content: 'Failed to update is_internal status for organization.',
      });
    }
  };

  return (
    <Card isFullWidth padding="medium">
      <Card.Content>
        <Accordion id="toggle-internal-org" isInitiallyOpen={false}>
          <Accordion.Target>
            Internal Organization
          </Accordion.Target>
          <Accordion.Body>
            <div>
              This will set the isInternal field for this organization.
              <br />
              DO NOT ENABLE THIS FOR CUSTOMER ORGANIZATIONS.
            </div>
            <LabeledCheckbox
              onChange={() => setShouldSetInternal(!shouldSetInternal)}
              label="Internal Organization"
              isChecked={shouldSetInternal}
            />
            <Button onClick={onButtonClick}>
              Update
            </Button>
          </Accordion.Body>
        </Accordion>
      </Card.Content>
    </Card>
  );
};

export default ToggleInternalOrgCard;
